import { render, staticRenderFns } from "./PaymentV2.vue?vue&type=template&id=35191823&scoped=true&"
import script from "./PaymentV2.vue?vue&type=script&lang=js&"
export * from "./PaymentV2.vue?vue&type=script&lang=js&"
import style0 from "./PaymentV2.vue?vue&type=style&index=0&id=35191823&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35191823",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VProgressCircular,VTextField})
